import { Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Results from './pages/Results';
import EventDetail from './pages/EventDetail';
import VenuePage from './pages/VenuePage';
import Suggest from './pages/Suggest';
import About from './pages/About';

export default function App() {
  return (
    <div className="app">
      <NavBar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/results" element={<Results />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/venues/:id" element={<VenuePage />} />
          <Route path="/suggest" element={<Suggest />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
